import React from 'react'
import HeaderReturn from './../../../../components.js/serveur/siteWeb/HeaderReturn'
import { useNavigate } from 'react-router-dom'

const HomeAdministrateur = () => {
    let navigate = useNavigate()

    return (
        <div className='container-fluid'>
            <HeaderReturn title='Administrateur' link='/'/>
            <div 
                className='h5 mt-5 ms-3'
                style={{ cursor:'pointer' }}
                onClick={() => navigate('/administrateur/createAccount')}
            >créer un nouveau compte</div>
            <div style={{ height:400 }} />
        </div>
    )
}

export default HomeAdministrateur
